<template>
  <div>
    <div class="w-full">
      <div
        class="px-2 py-5 md:p-5 md:4/5 lg:w-3/4 mx-auto text-center bg-white bg-opacity-25 rounded-lg"
      >
        <div
          class="text-custom text-xl lg:text-2xl mb-5 leading-none font-medium"
        >
          Reply Ticket
        </div>
        <div
          class="text-custom text-xl lg:text-2xl mb-5 leading-none font-medium title-txt"
        >
          Title: {{ ticketDetail.title }}
        </div>
        <ChatList v-bind:ticket-remarks="ticketDetail.remarks" />

        <div class="mt-2" v-if="ticketDetail.status != 'closed'">
          <ChatReply v-bind:ticket-detail="ticketDetail" />
        </div>
        <div class="mt-2" v-else>
          <div class="tkt-sts-des-ctr">Ticket has been closed</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ChatList from "@/components/ChatList.vue";
import ChatReply from "@/components/ChatReply.vue";

import TicketsService from "@/providers/tickets";
import firebase from "firebase";
import moment from "moment";

export default {
  name: "ReplyTicket",
  components: {
    ChatList,
    ChatReply
  },
  data() {
    return {
      ticketDetail: {}
    };
  },
  mounted() {
    let user = firebase.auth().currentUser;
    if (this.$route.params.id) {
      let ref = TicketsService.getTicketDetails(this.$route.params.id);
      if (ref && ref.on) {
        ref.on("value", data => {
          this.ticketDetail = data.val();
        });
      }
    }
  }
};
</script>

<style lang="postcss" scoped>
table thead tr th {
  @apply text-left py-5 px-4 uppercase font-semibold text-sm;
}
table tbody tr {
  @apply border-b border-gray-300;
}
table tbody tr td {
  @apply text-left py-3 px-4 border-r border-gray-300;
}
table tbody tr td:last-child,
table tbody tr:last-child {
  @apply border-none;
}
.title-txt {
  color: #fff;
}
.tkt-sts-des-ctr {
  color: #11b36d;
}
</style>
